var listOfMonth = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
var listOfDays = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
/**
 * Generate days current month of the date
 * @param {Date} date
 * @return {Array.<Object>}  return array of object date { date, month, year }
 */

var generateDays = date => {
  var _date = date;

  _date.setDate(1); //set date to first date of the month


  var firstDayIndexOfCurrentMonth = _date.getDay(); // return number index position first day of current month 


  var lastDayIndexOfCurrentMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDay(); // return number index position last day of current month 

  var lastDayOfCurrentMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate(); // return number last day of current month

  var lastDayOfPrevMonth = new Date(date.getFullYear(), date.getMonth(), 0).getDate(); // return number last day of previous month

  return [...generateDayLastMonth(date, firstDayIndexOfCurrentMonth, lastDayOfPrevMonth), ...generateDayCurrentMonth(date, lastDayOfCurrentMonth), ...generateDayNextMonth(date, lastDayIndexOfCurrentMonth)];
};
/**
 * Generate days last month
 * @param {Date} date // date
 * @param {Number} firstDayIndexOfCurrentMonth number index position first day of current month 
 * @param {Number} lastDayOfPrevMonth number last day of previous month
 * @returns {Array.<Object>} return array of object date { date, month, year }
 */


var generateDayLastMonth = (date, firstDayIndexOfCurrentMonth, lastDayOfPrevMonth) => {
  var length = firstDayIndexOfCurrentMonth !== 0 ? firstDayIndexOfCurrentMonth : 7;
  var days = new Array();

  for (var i = length - 2; i >= 0; i--) {
    //start with monday
    days = [...days, {
      date: lastDayOfPrevMonth - i,
      month: date.getMonth(),
      year: date.getFullYear()
    }];
  }

  return days;
};
/**
 * Generate days current month
 * @param {Date} date //date
 * @param {Number} lastDayOfCurrentMonth // last day of current month
 * @returns {Array.<Object>} return array of object date { date, month, year }
 */


var generateDayCurrentMonth = (date, lastDayOfCurrentMonth) => {
  var days = new Array();

  for (var i = 1; i <= lastDayOfCurrentMonth; i++) {
    days = [...days, {
      date: i,
      month: date.getMonth() + 1,
      year: date.getFullYear()
    }];
  }

  return days;
};
/**
 * Generate days current month
 * @param {Date} date //date
 * @param {Number} lastDayIndexOfCurrentMonth // number index position last day of current month 
 * @returns {Array.<Object>} return array of object date { date, month, year }
 */


var generateDayNextMonth = (date, lastDayIndexOfCurrentMonth) => {
  var length = lastDayIndexOfCurrentMonth !== 0 ? 7 - lastDayIndexOfCurrentMonth : lastDayIndexOfCurrentMonth;
  var days = new Array();

  for (var i = 1; i <= length; i++) {
    days = [...days, {
      date: i,
      month: date.getMonth() + 2,
      year: date.getFullYear()
    }];
  }

  return days;
};
/**
 * Get days current month of the date
 * Parsing date string to instance of date
 * @param {Date} date 
 * @return {Array.<Object>}  return array of object date { date, month, year }
 */


var getDays = date => {
  return generateDays(date);
};

export { listOfDays, listOfMonth, getDays };